import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import isEmpty from 'lodash/isEmpty';
import { styled } from '@mui/system';
import MuiGrid from '@mui/material/Grid';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@cpg-its/ads.common.tooltip';
import Typography from '@cpg-its/ads.common.typography';
import { blue, darkGrey } from '@cpg-its/ads.constants.colors';
const StyledFormControlLabel = styled(MuiFormControlLabel)({
    marginRight: '1.25rem',
});
const TooltipWrapper = styled(MuiGrid)(({ description }) => ({
    display: 'inline-flex',
    marginLeft: '.75rem',
    marginTop: description ? 12 : 0,
}));
const LabelContainer = styled(MuiGrid)(({ description }) => ({
    marginTop: description ? 12 : 0,
}));
export const FormControlLabelComponent = ({ control, description = '', label, labelColor, secondaryLabel = '', secondaryLabelColor, tooltip = {}, }) => {
    const renderSecondaryLabel = (() => {
        if (secondaryLabel) {
            return (_jsx(LabelContainer, { description: description, children: _jsx(Typography, { color: secondaryLabelColor ?? undefined, text: secondaryLabel, extraBold: true }) }));
        }
        return null;
    })();
    const renderTooltip = (() => {
        if (!isEmpty(tooltip)) {
            const { iconColor, backgroundColor, title } = tooltip;
            return (_jsx(TooltipWrapper, { description: description, children: _jsx(Tooltip, { iconColor: iconColor || blue, backgroundColor: backgroundColor, title: title }) }));
        }
        return null;
    })();
    return (_jsx(MuiGrid, { children: _jsxs(MuiGrid, { container: true, item: true, justifyContent: secondaryLabel ? 'space-between' : 'flex-start', children: [_jsx(StyledFormControlLabel, { control: control, label: (_jsxs(LabelContainer, { description: description, children: [label && (_jsx(Typography, { color: labelColor ?? undefined, text: label, extraBold: true })), description &&
                                _jsx(Typography, { text: description, color: darkGrey, variant: "caption" })] })) }), renderTooltip, renderSecondaryLabel] }) }));
};
export default FormControlLabelComponent;
//# sourceMappingURL=form-control-label.js.map